class mobileMenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const selected = this.getAttribute('data-selected')
        this.querySelector(`#${selected}-mobile`).classList.add('is-selected')

        const documentRoot = document.documentElement;
        let lastScrollTop = 0;

        window.addEventListener("scroll", () => {
            let scrollTop = document.documentElement.scrollTop;
            if (scrollTop > lastScrollTop) {
                documentRoot.setAttribute('data-scroll', 'down')
                
            } else if (scrollTop < lastScrollTop) {
                documentRoot.setAttribute('data-scroll', 'up')
            }
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        }, false);
    }
}

customElements.define("cstm-mobile-menu", mobileMenu);